module.exports = __webpack_public_path__ + "img/y-150.ee2b3506.png";